<template>
    <div>
        <app-form 
            v-bind:parentObject = "{
                data: this.formData,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
            
            v-on:input="formData = $event"
            v-on:save="saveHandler"
            v-on:error="errorHandler"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError = "{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
                v-on:closeError="isErr = $event"
            />
        </div>    
    </div>
</template>

<script>

import AlertForm from '../../../components/settings/alert/Form';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': AlertForm,
        'app-error': ErrorDialog
    },

    data() {
        return {
            pageTitle: this.$t('setupalert.newalert'),
            pageTitleValue : '',
            formData: {
                alerttype: null,
                secuser: null,               
                isdisable: 0,
                email: 0,
                alertbefore: null,
                alertafter: null,
                stamp: 0,
                userid: this.$store.getters.userId,                
                   
            },
            
            errMsg: '',
            isErr: false,
            editMode: false
        }
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            const vm = this;

            // Convert boolean to integer. 1 = true, 0 = false
            if (this.formData.isdisable == false) {
                this.formData.isdisable = 0;
            } else {
                this.formData.isdisable = 1;
            }

            if (this.formData.email == false) {
                this.formData.email = 0;
            } else {
                this.formData.email = 1;
            }

            

            this.$store.dispatch('post', {url: '/alertsetup/create', payload: this.formData})
                .then(res => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = res.data.error;
                    } else {
                        this.$router.push({name: 'alertlist'});
                    }
                })
                .catch(err => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
        },

        cancelHandler() {
            this.$router.push({name: 'alertlist'});
        },
    }
}
</script>